'use strict';
import * as $j_app$002e$002dEndpoints$0024$002dDocuments$0024 from "./app.-Endpoints$-Documents$.js";
import * as $j_app$002edata$002e$002dApp$002dDocument$002dCreate$002dRequest from "./app.data.-App-Document-Create-Request.js";
import * as $j_app$002epages$002e$002dApp$002dPage$0024$002dDocuments$002dView from "./app.pages.-App-Page$-Documents-View.js";
import * as $j_app$002epages$002e$002dApp$002dPage$0024$002dDocuments$002dView$0024 from "./app.pages.-App-Page$-Documents-View$.js";
import * as $j_app$002ewebclient$005fprelude$002eprelude$002eapp$005fbase$005furi$0024package$0024 from "./app.webclient_prelude.prelude.app_base_uri$package$.js";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_pages_DocumentsCreatePage$FormButtonActionForDocumentsCreate(reqSignal, lineage) {
  this.a8F = null;
  this.a8E = null;
  this.aXC = null;
  this.a8F = reqSignal;
  this.a8E = lineage;
  this.aXC = ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_airstream_core_Observable$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_airstream_extensions_OptionObservable$().oL(reqSignal, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1(((io) => $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_exts_FlatMapExts$package$().ne(io, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1(((x$1) => {
    if ((x$1 !== null)) {
      var authData = x$1.a0();
      var dataCreateRequest = x$1.a3();
      return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_exts_RequestExts$package$().kV($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_exts_ClientEndpointExts$package$().kE($j_app$002e$002dEndpoints$0024$002dDocuments$0024.$m_Lapp_Endpoints$Documents$().avF, authData, new $j_app$002edata$002e$002dApp$002dDocument$002dCreate$002dRequest.$c_Lapp_data_AppDocumentCreateRequest(lineage, dataCreateRequest), $j_app$002ewebclient$005fprelude$002eprelude$002eapp$005fbase$005furi$0024package$0024.$m_Lapp_webclient\uff3fprelude_prelude_app\uff3fbase\uff3furi$package$().hx()), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_sourcecode_DefinedAt(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsourcecode_File$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lsourcecode_File("/home/arturaz/work/chqmate/appClient/src/app/pages/DocumentsCreatePage.scala")), ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsourcecode_Line$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lsourcecode_Line(479)), ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsourcecode_FullName$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lsourcecode_FullName("app.pages.DocumentsCreatePage.FormButtonActionForDocumentsCreate.sendSignal"))));
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
  })), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcats_effect_IO$().dn)))));
}
export { $c_Lapp_pages_DocumentsCreatePage$FormButtonActionForDocumentsCreate as $c_Lapp_pages_DocumentsCreatePage$FormButtonActionForDocumentsCreate };
$p = $c_Lapp_pages_DocumentsCreatePage$FormButtonActionForDocumentsCreate.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_pages_DocumentsCreatePage$FormButtonActionForDocumentsCreate;
/** @constructor */
function $h_Lapp_pages_DocumentsCreatePage$FormButtonActionForDocumentsCreate() {
}
export { $h_Lapp_pages_DocumentsCreatePage$FormButtonActionForDocumentsCreate as $h_Lapp_pages_DocumentsCreatePage$FormButtonActionForDocumentsCreate };
$h_Lapp_pages_DocumentsCreatePage$FormButtonActionForDocumentsCreate.prototype = $p;
$p.z = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, (-889275714), false);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_pages_DocumentsCreatePage$FormButtonActionForDocumentsCreate)) {
    var x = this.a8F;
    var x$2 = x$0.a8F;
    if ((x === x$2)) {
      var x$3 = this.a8E;
      var x$4 = x$0.a8E;
      return ((x$3 === null) ? (x$4 === null) : x$3.f(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.n = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().V(this);
});
$p.s = (function() {
  return 2;
});
$p.t = (function() {
  return "FormButtonActionForDocumentsCreate";
});
$p.e = (function(n) {
  if ((n === 0)) {
    return this.a8F;
  }
  if ((n === 1)) {
    return this.a8E;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.u = (function(n) {
  if ((n === 0)) {
    return "reqSignal";
  }
  if ((n === 1)) {
    return "lineage";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.ar9 = (function(deleteTracker, formIsSubmitting, appPageInit) {
  $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_prelude_logging$package$().kx($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().m(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_O(["This should not be invoked."])), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_sourcecode_DefinedAt(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsourcecode_File$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lsourcecode_File("/home/arturaz/work/chqmate/appClient/src/app/pages/DocumentsCreatePage.scala")), ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsourcecode_Line$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lsourcecode_Line(468)), ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsourcecode_FullName$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lsourcecode_FullName("app.pages.DocumentsCreatePage.FormButtonActionForDocumentsCreate.deleteButton"))), "app");
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Seq$().ah();
});
$p.aus = (function() {
  return this.aXC;
});
$p.bEp = (function(body) {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(($j_app$002epages$002e$002dApp$002dPage$0024$002dDocuments$002dView$0024.$m_Lapp_pages_AppPage$DocumentsView$(), new $j_app$002epages$002e$002dApp$002dPage$0024$002dDocuments$002dView.$c_Lapp_pages_AppPage$DocumentsView(body)));
});
$p.aqv = (function(body) {
  return this.bEp(body);
});
function $isArrayOf_Lapp_pages_DocumentsCreatePage$FormButtonActionForDocumentsCreate(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ku)));
}
export { $isArrayOf_Lapp_pages_DocumentsCreatePage$FormButtonActionForDocumentsCreate as $isArrayOf_Lapp_pages_DocumentsCreatePage$FormButtonActionForDocumentsCreate };
var $d_Lapp_pages_DocumentsCreatePage$FormButtonActionForDocumentsCreate = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_pages_DocumentsCreatePage$FormButtonActionForDocumentsCreate, "app.pages.DocumentsCreatePage$FormButtonActionForDocumentsCreate", ({
  ku: 1,
  fV: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lapp_pages_DocumentsCreatePage$FormButtonActionForDocumentsCreate as $d_Lapp_pages_DocumentsCreatePage$FormButtonActionForDocumentsCreate };
//# sourceMappingURL=app.pages.-Documents-Create-Page$-Form-Button-Action-For-Documents-Create.js.map
